<template>
<div class="chapter">
<div class="inner_page">
<h1 class="book-title"><a id="page_iii"></a><img alt="" src="images/title.jpg"/></h1>
<p class="author">Jean-Christophe Valtat</p>
<p class="editor">Translated from the French by Mitzi Angel<br/>Farrar, Straus and Giroux / New York</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?3de40008